import { connect, MapDispatchToProps } from 'react-redux';
import { batchEditAttribute } from '../../../actions/studio';
import { BatchEditAttributeName } from '../../../types/batchActions';
import { Props } from './CommentsBatchEdit';

export type StateProps = Pick<Props, never>;
export type DispatchProps = Pick<Props, 'batchEditComments'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapDispatchToProps: MapDispatchToProps<
  DispatchProps,
  OwnProps
> = dispatch => ({
  batchEditComments: (allowComments: boolean) =>
    dispatch(
      batchEditAttribute(BatchEditAttributeName.ALLOW_COMMENTS, allowComments)
    ),
});

export default connect(null, mapDispatchToProps);
